import { Card, Col, List, Row, Skeleton, Space } from "antd";
import React, { useEffect } from "react";

import {
  DropDown,
  SearchInput,
  SubmitButton,
  TextComponent,
} from "../../../../components";
import styles from "./findvendors.module.css";
import Meta from "antd/es/card/Meta";
import dummyImg from "../../../../assets/dummy.jpg";
import img1 from "../../../../assets/staticImages/vendorimg1.png";
import img2 from "../../../../assets/staticImages/vendorimg2.png";
import img3 from "../../../../assets/staticImages/vendorimg3.png";
import img4 from "../../../../assets/staticImages/vendorimg4.png";
import img5 from "../../../../assets/staticImages/vendorimg5.png";
import img6 from "../../../../assets/staticImages/vendorimg6.png";
import { useState, memo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { VendorMiddleware } from "../../../../Store/Middlewares/VendorMiddleware";
import { AuthMiddleware } from "../../../../Store/Middlewares/AuthMiddleware";
const RenderItem = memo(({ item, loader }) => {
  const navigate = useNavigate();
  const { state } = useLocation();
  return (
    <div className={styles.listCont}>
      {loader ? 
    
      <Space style={{display:'flex',justifyContent:'center',flexDirection:'column', marginTop: '10px'}} >
        <Skeleton.Image active className={styles.image} />
        <Skeleton.Input active size={20} />
      </Space>
      :
      <Card
        // hoverable
        style={{ width: "100%" }}
        cover={
          <img
            className={styles.image}
            src={item.image ? item?.image : dummyImg}
            alt="example"
          />
        }
        onClick={() => {
          navigate("/findVendors/IndividulVendors", {
            state: { headrTitle: item.name, vendorData: item , eventData : state?.eventData},
          });
        }}
      >
        <Meta
          style={{ textAlign: "center" }}
          title={<TextComponent text={item.name} />}
          // description="www.instagram.com"
        />
      </Card>
}
    </div>
  );
});

const data = [
  {
    title: "Makeup Artisits",
    img: img6,
  },
  {
    title: "Decorators",
    img: img2,
  },
  {
    title: "Venues",
    img: img3,
  },
  {
    title: "Photographers",
    img: img4,
  },
  {
    title: "Wedding DJs",
    img: img5,
  },
  {
    title: "Planners",
    img: img1,
  },
];

const FindVendors = () => {
  const [loader, setloader] = useState(false);
  const [search, setSearch] = useState("");
  const [eventCategory, setEventCategory] = useState();
  const FindVendors = useSelector((state) => state?.VendorReducer?.findVendor);
  const EventCategory = useSelector(
    (state) => state?.GeneralReducer?.GeneralTypes?.servicecategory
  );
  const findVendorsPagination = useSelector(
    (state) => state?.VendorReducer?.findVendorsPagination
  );

  // console.log('EventCategory',EventCategory);
  const dispatch = useDispatch();
  const getData = (data = null) => {
    setloader(true);
    dispatch(VendorMiddleware.getFindVendors(data))
      .then(() => {
        setloader(false);
      })
      .catch(() => {
        setloader(false);
      });
  };
  useEffect(() => {
    getData();
    dispatch(AuthMiddleware.GeneralType());
  }, []);
  const onPressRenderMoreContent = () => {
    let data = {
      category_id: eventCategory?.id,
      findVendor_name: search,
      next_page_url: findVendorsPagination?.links?.next,
    };
    getData(data);
  };
  const onSubmit = () => {
    let data = {
      category_id: eventCategory?.id,
      findVendor_name: search,
      // next_page_url: findVendorsPagination?.links?.next,
    };
    getData(data);
  };

  return (
    <>
      <Row className={styles.searchContainer}>
        <Col className={styles.category}>
          <DropDown
            placeholder={"Category"}
            onChange={(e) => setEventCategory(e)}
            selectedValue={eventCategory?.val}
            object={EventCategory}
          />
        </Col>

        <Col className={styles.search}>
          <SearchInput
            placeholder={"Search"}
            onChange={(e) => setSearch(e.target.value)}
            value={search}
          />
        </Col>
        <Col className={styles.category}>
          <SubmitButton title="Search" onClick={onSubmit} />
        </Col>
      </Row>
      <Row className={styles.textCont}>
        <TextComponent
          textClass={styles.text}
          text="Make your event amazing by choosing the right vendor. Find the vendors now & get started!"
        />
      </Row>
      <List
        grid={{
          xs: 1,
          sm: 2,
          md: 2,
          lg: 3,
          xl: 3,
          xxl: 3,
        }}
        dataSource={FindVendors}
        renderItem={(item) => <RenderItem item={item} loader={loader} />}
        footer={
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {findVendorsPagination?.links?.next != null ? (
              <div style={{ width: "50%" }}>
                <SubmitButton
                  title={"Load More"}
                  onClick={onPressRenderMoreContent}
                />
              </div>
            ) : null}
          </div>
        }
      />
    </>
  );
};

export default FindVendors;
